import React from 'react';
import PropTypes from 'prop-types';
import { SecondaryButtonContainer } from './SecondaryButton.styles';
// Secondary Button Component
const SecondaryButton = React.memo(
  ({ functionName, span, className, style, disabled = false }) => {
    return (
      <SecondaryButtonContainer
        onClick={functionName}
        className={className}
        style={style}
        disabled={disabled}
      >
        {span}
      </SecondaryButtonContainer>
    );
  }
);
SecondaryButton.displayName = 'SecondaryButton';
SecondaryButton.propTypes = {
  functionName: PropTypes.func,
  span: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

export default SecondaryButton;
